<div class="login-page-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-8 d-flex flex-column justify-content-center">
        <div class="text-white">
          <h3>Welcome to</h3>
          <h1>Business Control</h1>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum
            eligendi exercitationem sint.
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div
          class="
            login-form
            text-center
            d-flex
            flex-column
            justify-content-center
          "
        >
          <img class="mb-4" src="../assets/images/logo.png" alt="" srcset="" />
          <form [formGroup]="signInForm">
            <div class="row g-2 mb-3 justify-content-between phone-field">
              <mat-form-field appearance="outline" class="col-3">
                <mat-label>Country</mat-label>
                <mat-select formControlName="country" required (selectionChange)="onCountrySelected($event)" >
                  <mat-select-trigger>
                    {{ "(" + countryCode.value.dial_code + ")" }}
                  </mat-select-trigger>
                    <input
                    style="width: 80%;
                    height: 25px;
                    padding: 10px;
                    border: 1px solid lightgray;
                    margin: 10px;
                    border-radius: 5px;
                "
                    [formControl]="searchString"
                     
                      matInput
                      placeholder="Enter country name"
                      (keyup)="onKey()"
                    />
                  <mat-option
                    *ngFor="let country of countryList"
                    [value]="country"
                    
                  >
                    {{ country.flag }} {{ country.name }} 
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
             
              <mat-form-field appearance="outline" class="col-9">
                <mat-label>Phone number</mat-label>
                <input
                  matInput
                  type="tel"
                  maxlength="10"
                  formControlName="phone"
                  required
                />
                <button
                  type="button"
                  mat-button
                  matSuffix
                  color="primary"
                  [disabled]="
                    countryCode.invalid ||
                    phoneControl.invalid ||
                    sendingOtpStatus
                  "
                  (click)="onSendOTP()"
                >
                  Send OTP
                </button>
                <mat-error>Invalid phone number!</mat-error>
                <mat-hint>Enter 10 digit phone number</mat-hint>
              </mat-form-field>
            </div>
            <div class="mb-3" *ngIf="otpReceived">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Enter OTP</mat-label>
                <input
                  matInput
                  type="text"
                  maxlength="6"
                  formControlName="otp"
                  required
                />
                <mat-error>Invalid OTP</mat-error>
              </mat-form-field>
            </div>

            <button
              mat-flat-button
              color="accent"
              class="w-100"
              [disabled]="signInForm.invalid || sendingOtpStatus"
              (click)="onSignIn()"
              #submitButton
            >
              Sign in
            </button>
          
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
